module.exports = __webpack_public_path__ + "img/letterpress.f52de251.jpg";